import { getStore } from '../../Store'
const store = getStore();

export const IsJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const CopyToClipboard = (str) => {
    navigator.clipboard.writeText(str);
    store.updateSuccessMessage("Copied to clipboard!")
}